import { createRouter, createWebHistory } from 'vue-router';

import store from '../store';

import Layout from '@/containers/layout/index.vue';

const routes = [
  // 404 page must be placed at the end !!!
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index.vue'),
      },
      {
        path: 'ourwork',
        name: 'Ourwork',
        component: () => import('@/views/ourwork.vue'),
      },
      {
        path: 'ourwork/detail/:id?',
        name: 'OurworkDetail',
        component: () => import('@/views/ourworkDetail.vue'),
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/news.vue'),
      },
      {
        path: 'news/detail/:id?',
        name: 'NewsDetail',
        component: () => import('@/views/newsDetail.vue'),
      },
      {
        path: 'aboutUs',
        name: 'AboutUs',
        component: () => import('@/views/aboutUs.vue'),
      },
      {
        path: 'partnerships',
        name: 'Partnerships',
        component: () => import('@/views/partnerships.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/index',
  },
];

const routerHistory = createWebHistory();

const router = createRouter({
  history: routerHistory,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 检查用户是否登录
    if (!store.getters.isAuthenticated) {
      next({ name: 'Index' });
    } else {
      next();
    }
  } else {
    // 特殊处理：如果已登录，访问 /login 则重定向到 /userCenter
    if (to.name === 'Login' && store.getters.isAuthenticated) {
      next({ name: 'UserCenter' });
    } else {
      next();
    }
  }
});

export default router;
